import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import map from 'lodash/map';
import find from 'lodash/find';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { currentUserSelector, myProjectsSelector, sharedProjectsSelector, projectsSelector } from '../../reducers/selectors';


const mapStateToProps = state => ({ isLoading: state.loaders.projects, currentUser: currentUserSelector(state), projects: projectsSelector(state), myProjects: myProjectsSelector(state), sharedProjects: sharedProjectsSelector(state), currentProject: state.currentProject});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};




const ProjectsMenuItems = ({myProjects, sharedProjects, selectProject}) => {
  
  return (<React.Fragment>
    {myProjects.length > 0 && <DropdownItem header>My Projects</DropdownItem>}
    {map(myProjects, (project, idx) => (
      <DropdownItem key={idx} onClick={() => selectProject(project.id)}>
        {project.name}
      </DropdownItem>
    ))}
    {sharedProjects.length > 0 && <DropdownItem header>Shared Projects</DropdownItem>}
    {map(sharedProjects, (project) => (
      <DropdownItem key={project.id} onClick={() => selectProject(project.id)}>
        {project.name}
      </DropdownItem>
    ))}
  </React.Fragment>)
}


class ProjectSelect extends Component {
  
  constructor (props) {
    super(props);
    
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onSelect = this.onSelect.bind(this);
    
    this.state = {
      dropdownOpen: false,
    }
  }
  
  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  
  onSelect(value) {
    const { input } = this.props
    const onChange = (input && input.onChange) || this.props.onChange
    
    if (onChange)
      onChange(value)
  }
  
  render() {
    const { projects, myProjects, sharedProjects, input } = this.props;
    const value = (input && input.value) || this.props.value
    const selectedProject = value && find(projects, {id: value})
    
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
        
        <DropdownToggle className="btn" color="standart" outline caret>
          {(selectedProject || {name: 'Select project'}).name}
        </DropdownToggle>
        
        <DropdownMenu>
          <ProjectsMenuItems {...{myProjects, sharedProjects, selectProject: this.onSelect}} />
        </DropdownMenu>
        
      </Dropdown>
    )
  }
};


export default connect(mapStateToProps, matchDispatchToProps)(ProjectSelect);


// WEBPACK FOOTER //
// ./src/components/Projects/ProjectSelect.js